
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, Title, Meta } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { CommonModule, DecimalPipe } from '@angular/common';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

import { SharedModule } from './shared/shared.module';
import { WwwInfoModule } from './www-info/www-info.module';
import { WwwPropertiesModule } from './www-properties/www-properties.module';


import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSliderModule } from '@angular/material/slider';

import { environment } from '../environments/environment';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

registerLocaleData(localeEs, 'es-ES', localeEsExtra);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    SharedModule,
    CommonModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    WwwInfoModule,
    WwwPropertiesModule,
    NgxSliderModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatSliderModule,
    RecaptchaV3Module
  ],
  providers: [Title, { provide: LOCALE_ID, useValue: 'es-ES' }, DecimalPipe, {
    provide: RECAPTCHA_V3_SITE_KEY,
    useValue: environment.recaptcha.siteKey,
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
